import { DecimalPipe, UpperCasePipe } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
  AmountHelper,
  OnyxDataWidgetComponent,
  OnyxDatePipe,
  OnyxTableComponent,
  OnyxTooltipDirective,
} from '@onyx/angular';
import { AmountCellComponent } from '../../../../../../../common/components/cells/amount-cell/amount-cell.component';
import { DictionaryCode } from '../../../../../../../common/enums/dictionary-code';
import { NumberDecorationPipe } from '../../../../../../../common/pipes/number-decoration.pipe';
import { ORDER_MODAL_PLAN_FINANCES_COLUMNS } from '../../../../../common/constants/order-modal-plan-finances-columns';
import type { OrderSettlementData } from '../../../../../common/helpers/order.helper';
import { OrderHelper } from '../../../../../common/helpers/order.helper';
import type { Order } from '../../../../../common/interfaces/order';

@Component({
  selector: 'app-order-modal-plan-finances',
  imports: [
    AmountCellComponent,
    OnyxDataWidgetComponent,
    NumberDecorationPipe,
    DecimalPipe,
    TranslatePipe,
    UpperCasePipe,
    OnyxTableComponent,
    OnyxTooltipDirective,
    OnyxDatePipe,
  ],
  templateUrl: './order-modal-plan-finances.component.html',
  styleUrl: './order-modal-plan-finances.component.scss',
})
export class OrderModalPlanFinancesComponent {
  public readonly order = input.required<Order>();

  protected readonly I18N = 'orders.orderModal.plan';
  protected readonly ORDER_MODAL_PLAN_FINANCES_COLUMNS =
    ORDER_MODAL_PLAN_FINANCES_COLUMNS;

  protected readonly DictionaryCode = DictionaryCode;

  protected settlementData = computed<OrderSettlementData[]>(() =>
    OrderHelper.getSettlementData(this.order()),
  );

  protected kmRate = computed(() => OrderHelper.getKmRate(this.order()));
  protected dailyRate = computed(() => OrderHelper.getDailyRate(this.order()));
  protected plannedData = computed(() => {
    const { status, route, price } = this.order();
    if (!OrderHelper.isFinished(status.value)) return;

    return {
      price,
      kmRate: AmountHelper.divide(price, route.summary.distance / 1000),
    };
  });
}
